import { AppletEmptyStateIncompatible } from './empty-state-incompatible';
import { AppletEmptyStateNoData } from './empty-state-no-data';
import { AppletEmptyStateNoDocuments } from './empty-state-no-documents';
import { AppletEmptyStateNoSearch } from './empty-state-no-search';
import { AppletEmptyStatePaymentRequired } from './empty-state-payment-required';
import { AppletEmptyStateReports } from './empty-state-reports';
import { AppletEmptyStateQueryTooComplex } from './empty-state-query-too-complex';
import { AppletEmptyStateSearchTimeout } from './empty-state-search-timeout';
import { AppletEmptyStateUnconfigured } from './empty-state-unconfigured';
import { generatePrefixedTagName } from '../generate-prefixed-tag-name';
import { isValidAppletEmptyState, AppletEmptyStateType } from '../applet-empty-state-type';
import { safelyDefineCustomElement } from '../safely-define-custom-element';
import { AppletEmptyStateTooManyInputs } from './empty-state-too-many-inputs';

const attributes = {
    TYPE: 'type'
};

export class AppletEmptyState extends HTMLElement {
    static get observedAttributes() {
        return [
            attributes.TYPE
        ];
    }

    static get tagName() {
        return generatePrefixedTagName`applet-empty-state`;
    }

    constructor() {
        super();
        this.__root = this.attachShadow({mode: 'open'});
    }

    attributeChangedCallback(name, __, newValue) {
        if(name === attributes.TYPE) {
            if(isValidAppletEmptyState(newValue)) {
                this.type = newValue;
            } else {
                this.errors = `Invalid type passed. Provided value: ${newValue}`;
            }
        }
        this.__render();
    }

    connectedCallback() {
        this.__render();
    }

    __render() {
        if(this.errors) {
            this.__root.innerHTML = `<div class="applet-empty-state__errors">${this.errors}</div>`;
        } else {
            let emptyStateTagName;
            switch (this.type) {
                case AppletEmptyStateType.INCOMPATIBLE:
                    emptyStateTagName = AppletEmptyStateIncompatible.tagName;
                    break;
                case AppletEmptyStateType.NO_DATA:
                    emptyStateTagName = AppletEmptyStateNoData.tagName;
                    break;
                case AppletEmptyStateType.NO_DOCUMENTS:
                    emptyStateTagName = AppletEmptyStateNoDocuments.tagName;
                    break;
                case AppletEmptyStateType.NO_SEARCH:
                    emptyStateTagName = AppletEmptyStateNoSearch.tagName;
                    break;
                case AppletEmptyStateType.PAYMENT_REQUIRED:
                    emptyStateTagName = AppletEmptyStatePaymentRequired.tagName;
                    break;
                case AppletEmptyStateType.REPORTS:
                    emptyStateTagName = AppletEmptyStateReports.tagName;
                    break;
                case AppletEmptyStateType.QUERY_TOO_COMPLEX:
                    emptyStateTagName = AppletEmptyStateQueryTooComplex.tagName;
                    break;
                case AppletEmptyStateType.SEARCH_TIMEOUT:
                    emptyStateTagName = AppletEmptyStateSearchTimeout.tagName;
                    break;
                case AppletEmptyStateType.TOO_MANY_INPUTS:
                    emptyStateTagName = AppletEmptyStateTooManyInputs.tagName;
                    break;
                case AppletEmptyStateType.UNCONFIGURED:
                default:
                    emptyStateTagName = AppletEmptyStateUnconfigured.tagName;
                    break;
            }
            this.__root.innerHTML = `<${emptyStateTagName}></${emptyStateTagName}`;
        }
    }
}

safelyDefineCustomElement(AppletEmptyState);